// src/components/StatsCard.jsx
import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { TrendingUp } from 'lucide-react';

export function StatsCard({ title, value, change, data, color }) {
  const options = {
    chart: { type: 'areaspline', backgroundColor: null, height: 60 },
    title: { text: null },
    xAxis: { visible: false },
    yAxis: { visible: false },
    tooltip: { enabled: false },
    credits: { enabled: false },
    series: [{ data, color }]
  };

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <div>
          <p className="text-sm font-medium text-gray-500">{title}</p>
          <p className="text-2xl font-bold text-gray-900">{value.toLocaleString()}</p>
        </div>
        <div className="flex items-center space-x-1 text-sm font-medium">
          <TrendingUp size={16} className={`text-${color}-500`} />
          <span className={`text-${color}-600`}>{change}%</span>
        </div>
      </div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
}
